import {
  Accordion,
  AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box,
  Button, Flex, Heading, IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay, Text, useToast
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGetQuestionnairesNotes } from "../../../../../../hooks/query/reports";
import { hideAppSpinner, showAppSpinner } from "../../../../../../context/Store/slices/appSpinnerSlice";
import { showErrorToast } from "../../../../../../utils";
import { useDispatch } from "react-redux";
import { FaDownload } from "react-icons/fa";
import { useGetCategoryAttachment } from "../../../../../../hooks/query";

function NotesModal({ isOpen, onClose, year, quarter }) {
  const { t: globalTranslation } = useTranslation("translation");
  const { t } = useTranslation("translation", {
    keyPrefix: "companyEmissionsDashboard.totalEmissions.notesModal"
  });
  const toast = useToast();
  const dispatch = useDispatch();

  const {
    data
  } = useGetQuestionnairesNotes({ year, quarter }, {
    onError: error => showErrorToast(toast, error.response?.data?.parameters?.message ?? error.message),
    onSettled: () => dispatch(hideAppSpinner()),
    cacheTime: 0
  });

  const filteredData = data?.filter(q =>
    q.notes && q.notes.length > 0 &&
    q.notes.filter(noteObj =>
      (noteObj.note && noteObj.note !== "") ||
      (noteObj.attachment && typeof noteObj.attachment !== "undefined" &&
        noteObj.attachment.attachmentId !== null && typeof noteObj.attachment.attachmentId !== "undefined")
    ).length > 0
  ) ?? [];

  const config = {
    onMutate: () => dispatch(showAppSpinner()),
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    onSettled: () => dispatch(hideAppSpinner()),
    cacheTime: 0
  };

  const { mutate: downloadAttachment } = useGetCategoryAttachment(config);

  const handleDownloadAttachment = (attachmentId) => {
    downloadAttachment({ attachmentId });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("title")}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          {filteredData.length > 0 ?
            <Accordion height="500px" overflow="auto" defaultIndex={[0]} allowToggle={true}>
              {filteredData.map((questionnaire, index) => {
                return <AccordionItem key={`${questionnaire.assignee}-${index}`}>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      <Heading color="esg_gray.200" size="xs">
                        <Text fontSize="md" fontWeight="bold">
                          {t("period")}: {questionnaire.period?.year ?? ""} {questionnaire.period?.quarter ?? ""}, {t("filledInBy")}: {questionnaire.assignee}, {t("dimensions")}: {!questionnaire.dimensions ?
                          t("all") : questionnaire.dimensions.map(dim => `${dim.name} - ${dim.value}`).join(", ")}
                        </Text>
                      </Heading>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel pb={4}>
                    <Flex flexDirection="column" gap={4}>
                      {questionnaire.notes
                        .filter(el => el && ((el.note && el.note !== "") ||
                          (el.attachment && el.attachment.attachmentId !== null && typeof el.attachment.attachmentId !== "undefined")))
                        .map((el, elIndex) => {
                          return (
                            <Flex key={`note-${index}-${elIndex}`} flexDirection="column"
                                  backgroundColor={elIndex % 2 === 1 ? "#EDF2F7" : null} padding={3}>
                              <Text fontSize="md">
                                <b>{t("scope")} 3, {el.categoryName}</b>
                              </Text>
                              {el.note ? <Text fontSize="md" whiteSpace="pre-line">
                                <b>{t("notes")}:</b> {el.note}
                              </Text> : null}
                              {el.attachment && el.attachment.attachmentId !== null &&
                              typeof el.attachment.attachmentId !== "undefined" ?
                                <Flex alignItems="center" gap={2}>
                                  <Text fontSize="md" whiteSpace="pre-line">
                                    <b>{t("attachments")}:</b>
                                  </Text>
                                  <Text maxWidth="50%" textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden"
                                        title={el.attachment.attachmentName}>
                                    {el.attachment.attachmentName ?? "Attachment"}
                                  </Text>
                                  <IconButton
                                    aria-label="download-attachment-button"
                                    type="button"
                                    icon={<FaDownload color="green" />}
                                    flexShrink="0"
                                    backgroundColor="transparent"
                                    size="sm"
                                    opacity="0.7"
                                    tabIndex={-1}
                                    onClick={() => handleDownloadAttachment(el.attachment.attachmentId)}
                                    title={t("downloadBtnTooltip")}
                                    width="14px"
                                    height="14px"
                                  />
                                </Flex> : null
                              }
                            </Flex>
                          );
                        })
                      }
                    </Flex>
                  </AccordionPanel>
                </AccordionItem>;
              })}
            </Accordion> : t("noQuestionnairesWithNotes")
          }
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            {globalTranslation("buttons.close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default NotesModal;